module.exports = __webpack_public_path__ + "img/p1_bg.f126ae6d.jpg";